import { Permission } from 'lib/enum/permission.enum';

export enum Context {
    Default = 'DEFAULT',
    BusinessAccount = 'BUSINESS_ACCOUNT',
    Product = 'PRODUCT',
    ProductItem = 'PRODUCT_ITEM',
}

const CONTEXT_DISPLAY_NAMES = {
    [Context.Default]: 'Default',
    [Context.BusinessAccount]: 'Business Account',
    [Context.Product]: 'Product',
    [Context.ProductItem]: 'Product Item',
};

export const getContextDisplayName = (context: Context): string => CONTEXT_DISPLAY_NAMES[context];

export const isCascading = (context: Context): boolean => cascadingContext.get(context)!;

const cascadingContext = new Map<Context, boolean>([
    [Context.Default, false],
    [Context.BusinessAccount, true],
    [Context.Product, true],
    [Context.ProductItem, false],
]);

export const getBroaderContext = (context: Context): Context => {
    const contexts = getBroaderOrEqualContextsHierarchy(context);
    contexts.pop();
    if (contexts.length < 1) {
        throw new Error('Unable to get broader context');
    }
    return contexts.pop()!;
};

export const getBroaderOrEqualContextsHierarchy = (context: Context): Array<Context> => {
    const hierarchy = getContextsHierarchy();
    const contextIndex = hierarchy.indexOf(context);

    return hierarchy.filter((context, index) => index <= contextIndex);
};

const getContextsHierarchy = (): Array<Context> => [
    Context.Default,
    Context.BusinessAccount,
    Context.Product,
    Context.ProductItem,
];

export const getEditRolesPermissionCorrespondingToContext = (context: Context): Permission =>
    correspondingRoleEditPermissions.get(context)!;

const correspondingRoleEditPermissions = new Map<Context, Permission>([
    [Context.BusinessAccount, Permission.businessAccountMembersManage],
    [Context.Product, Permission.productRolesManage],
    [Context.ProductItem, Permission.productItemRolesManage],
]);
